import { render, staticRenderFns } from "./ProjectTotals.vue?vue&type=template&id=31148172&scoped=true"
import script from "./ProjectTotals.vue?vue&type=script&lang=js"
export * from "./ProjectTotals.vue?vue&type=script&lang=js"
import style0 from "./ProjectTotals.vue?vue&type=style&index=0&id=31148172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31148172",
  null
  
)

export default component.exports